import OKVideo from 'OK/OKVideo';

export default class VideoEmbed {
    constructor() {
        this.element = null;
        this.clickElement = null;

        var clickHandler = function () {
            this.clickElement.click();
        }.bind(this);

        this.messageHandler = function (e) {
            switch (e.data.action) {
                case 'play':
                    if (OKVideo.getPlayerId()) {
                        OKVideo.play();
                    } else {
                        clickHandler();
                    }
                    break;

                case 'pause':
                    OKVideo.pause();
                    break;

                case 'stop':
                    OKVideo.stop();
                    break;

                case 'volume':
                    OKVideo.volume(e.data.value);
                    break;

                case 'mute':
                    OKVideo.setMuted(true);
                    break;

                case 'unmute':
                    OKVideo.setMuted(false);
                    break;

                case 'seek':
                    OKVideo.seek(e.data.time);
                    break;
            }
        }.bind(this);
    }

    activate(element) {
        this.element = element;
        this.clickElement = element.querySelector('.vid-card_cnt_w');

        window.addEventListener('message', this.messageHandler, false);
        OK.VideoPlayer && OK.VideoPlayer.yandexStat('inited');
    }

    deactivate(element) {
        this.element = null;
        this.clickElement = null;

        window.removeEventListener('message', this.messageHandler, false);
    }
}
